module.exports = __webpack_public_path__ + "260d4ceebc9f9de6e481ad82a31ff979.svg";